<template>
	 <b-row class="my-1" align-v="center">
      <b-col :sm="labelWidth"  class="text-left">
      <label class="mb-0 align-middle">{{this.label}}</label>
      </b-col>
      <b-col :sm="inputWidth">
	  <b-form-radio-group v-model="value"  :options="options" :stacked="this.stacked" :disabled='this.disabled' @change="change($event)"></b-form-radio-group>
     </b-col>
    </b-row>
</template>

<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'

export default{
	name:'FITRadio',
	props:{
		label:String,
		options:{  
			type:Array,
			required:true
		},	
		width:Number,
		stacked:Boolean,  // Orientation: true for Vertical, false for horizontal 
    value:String,
    disabled:Boolean
	},
  data(){
  	return{
	    inputWidth:this.width,
	   }
  },

  mounted(){
    this.labelCheck(this.label);
  },
  computed:{
  	labelWidth(){
  		return 12-this.inputWidth;
  	}
  },
   methods:{
    labelCheck(label){
      if(!label){
        this.inputWidth=12;
      }
    },
    change(event){
      this.$emit('input', event);
    }
  }
}	
</script>
<style type="text/css">
	.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #007bff;
}
</style>


// WEBPACK FOOTER //
// src/components/Form/FITRadio.vue